// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteChange_container__3kqQY"};